export const contactsData = {
  email: "ramkumarpsy(at)gmail(dot)com",
  phone: "9 5 6 6 7 - 3 6 3 7 5",
  address: "Madurai, Tamilnadu",
  sheetAPI: "https://sheetdb.io/api/v1/p74g4fsqax1h4",
};
